import apiClient from '@/services/axios'

export async function del(appGameId) {
  var response = await apiClient.delete('/appGame/' + appGameId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to App Game.')
}